<div class="main-content">
    <p style="color: red;"><b>You seem to be working offline or not on the Intel Network.</b></p>
    <p>Please connect to the Intel Network using Cisco AnyConnect Secure Mobility Client (VPN) app first, close this browser window, and then try again.</p>
    <p style="color: red;">The error message was: {{errorMessage}} </p>
</div>
  